
    import { Options, Vue } from 'vue-class-component';

    @Options({
        components: {},
    
        props: {
            // ticketId: {
            //     type: String,
            //     required: true,
            //     default: null
            // }
        },

        data() {
            return {
                paymethods: [
                    { id: 1, method: 'card', name: 'Credit card'},
                    { id: 2, method: 'momo', name: 'MTN Momo'},
                    { id: 3, method: 'paypal', name: 'Paypal'}
                ],
                paymentDetailsCard: {
                    "card_number": '',
                    "cvv": '',
                    "expiry_date": '',
                    "fullnames": '',
                    "email_address": '',
                    "phone_number": '',
                    "method": ''
                },

                card_number_invalid: false,
                cvv_invalid: false,
                expiry_date_invalid: false,
                fullnames_invalid: false,
                email_address_invalid: false,
                phone_number: false,

                paymentDetailsMomo: {
                    'momouser': '',
                    'email': '',
                    'number': '',
                    'method': '' 
                },

                number_invalid: false,
                email_invalid: false,
                momouser_invalid: false,

                paymentDetailsPaypal: {
                    "method": ''
                },

                method: 'momo',
                error_msg: '',
                has_errors: false
            }
        },

        methods: {
            getholder() {
                this.fullnames_invalid = false
            },

            getemail() {
                this.email_address_invalid = false;
                this.email_invalid = false;
            },

            getcvv() {
                this.cvv_invalid = false
            },

            getdate() {
                this.expiry_date_invalid = false
            },

            stopErrors() {
                this.error_msg = '';
                this.has_errors = false;
                this.card_number_invalid = false;
                this.cvv_invalid = false;
                this.expiry_date_invalid = false;
                this.fullnames_invalid = false;
                this.email_address_invalid = false;
                this.phone_number = false;
                this.number_invalid = false;
                this.email_invalid = false;
                this.momouser_invalid = false;
            },

            getnumber() {
                this.number_invalid = false;
            },

            getmomouser() {
                this.momouser_invalid = false;
            },

            getValue() {
                this.card_number_invalid = false;
                if(this.paymentDetails.cardNumber.length == 4) {
                    this.paymentDetails.cardNumber = this.paymentDetails.cardNumber + '  ';
                }

                if(this.paymentDetails.cardNumber.length == 10) {
                    this.paymentDetails.cardNumber = this.paymentDetails.cardNumber + '  ';
                }

                if(this.paymentDetails.cardNumber.length == 16) {
                    this.paymentDetails.cardNumber = this.paymentDetails.cardNumber + '  ';
                }
            },

            getticket() {
                this.paymentDetailsMomo.email = this.paymentDetailsMomo.email;
                this.paymentDetailsMomo.method = this.method;
                this.paymentDetailsPaypal.method = this.method;
                this.paymentDetailsCard.method = this.method;
                this.paymentDetailsCard.phone_number = this.$store.state.UserDetails.user.telephone;
                // this.paymentDetailsMomo.momouser = this.$store.state.UserDetails.user.firstname+ ' ' + this.$store.state.UserDetails.user.lastname;
            },

            payandbook() {
                this.paymentDetailsMomo.method = this.method;
                this.paymentDetailsPaypal.method = this.method;
                this.paymentDetailsCard.method = this.method;

                if (this.method == 'momo') {
                    if (this.paymentDetailsMomo.momouser == '') {
                        this.has_errors = true;
                        this.error_msg = 'You names are required!'
                        this.momouser_invalid = true;
                        return;
                    }
                     if (this.paymentDetailsMomo.email == '') {
                        this.has_errors = true;
                        this.error_msg = 'Email is required!'
                        this.email_invalid = true;
                        return;
                    }
                    if (this.paymentDetailsMomo.number == '') {
                        this.has_errors = true;
                        this.error_msg = 'Phone number is required!'
                        this.number_invalid = true;
                        return;
                    }
                   
                    this.$store.commit('Booking/payTicket', this.paymentDetailsMomo)
                }

                if (this.method == 'card') {

                    if (this.paymentDetailsCard.card_number == '') {
                        this.has_errors = true;
                        this.error_msg = 'Card number is required!';
                        this.card_number_invalid = true;
                        this.$store.commit('Booking/stopSubmitting');
                        return;
                    }
                    
                    if (this.paymentDetailsCard.fullnames == '') {
                        this.has_errors = true;
                        this.error_msg = 'Fullnames is required!'
                        this.fullnames_invalid = true;
                        return;
                    }

                     if (this.paymentDetailsCard.email_address == '') {
                        this.has_errors = true;
                        this.error_msg = 'Email address is required!'
                        this.email_address_invalid = true;
                        return;
                    }

                    if (this.paymentDetailsCard.expiry_date == '') {
                        this.has_errors = true;
                        this.error_msg = 'Expiry date is required!'
                        this.expiry_date_invalid = true;
                        return;
                    }
                    
                    if (this.paymentDetailsCard.cvv == '') {
                        this.has_errors = true;
                        this.error_msg = 'Cvv is required!'
                        this.cvv_invalid = true;
                        return;
                    }

                    this.$store.commit('Booking/', this.paymentDetailsCard)
                }

                if (this.method == 'paypal') {
                    this.$store.commit('Booking/payTicket', this.paymentDetailsPaypal)
                }
            }
           
        },

        
        updated() {
            this.getticket();                   
        },

       



    })
    export default class BookingPayment extends Vue {
        
    }     
   
